<template>
  <section class="section-base form-section-base">
    <div class="form-base">
      <FormView
        :statement-id="statementId"
        :original-statement-id="originalStatementId"
        :is-alternative-service-edit="isAlternativeServiceEdit"
      />
    </div>

    <div class="form-base__footer">
      <v-container>
        <v-row>
          <v-col>
            <div class="button-box">
              <v-btn
                depressed
                color="primary"
                :disabled="!ServicesModule.statement.xmlFileLink"
                :href="getFileLink(ServicesModule.statement.xmlFileLink)"
                class="button-base"
                >Скачать заявление
              </v-btn>
              <v-btn
                @click="prevStep"
                :loading="loadingNext"
                :disabled="loadingNext"
                depressed
                color="primary"
                class="button-base ml-5"
                >Назад
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </section>
</template>

<script>
import { ServicesModule } from '@/store/modules/services';
import FormView from '@/components/elements/statement/FullStatementView/FormView';
import { getFileLink } from '@/api/filestorage';
import { StepDirection } from '@/types/services';

export default {
  name: 'StepView',
  props: {
    statementId: {
      type: String,
    },
    originalStatementId: {
      type: String,
    },
    loadingNext: {
      type: Boolean,
      required: true,
    },
    isAlternativeServiceEdit: {
      type: Boolean,
    }
  },
  components: { FormView },
  data() {
    return {
      ServicesModule,
      getFileLink,
    };
  },
  methods: {
    prevStep() {
      this.$emit(StepDirection.PREV, {
        fragment: {},
        step: '',
      });
    },
  },
};
</script>

<style scoped lang="scss"></style>
